module.exports = __webpack_public_path__ + "static/media/Investor-AINE DENARI_1646328000729.de725286.vtt";